import type { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const IconCheckmark: FC<Props> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      {...props}
      fill="none"
    >
      <path
        d="M20.7799 6.70072C21.073 6.40808 21.0734 5.93321 20.7808 5.64006C20.4882 5.34691 20.0133 5.34649 19.7201 5.63912L8.58047 16.7697L4.28033 12.4696C3.98744 12.1767 3.51256 12.1767 3.21967 12.4696C2.92678 12.7625 2.92678 13.2374 3.21967 13.5303L8.04967 18.3603C8.34238 18.653 8.81689 18.6532 9.10986 18.3607L20.7799 6.70072Z"
        fill={props.fill || "currentColor"}
      />
    </svg>
  );
};

export default IconCheckmark;
